import React from "react";
import Aos from "aos";
import "./style.css";
const Training = () => {
  React.useEffect(() => {
    Aos.init({
      offset: 10,
      once:true,
      duration: 600,
      easing: "ease-in-sine",
      delay: 200,
    });
  });
  return (
    
  <div className="main" >
    <main className="table" data-aos="slide-right">
      <section className="table__header">
        <h1 className="servicesTableHeading" >ISO Training Courses</h1>
      </section>
      <section className="table__body">
        <table>
          <thead>
            <tr>
              <th>No.</th>
              <th>Service ID</th>
              <th>Service Name</th>
              <th>Service Description</th>
              <th>Course Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>ISO 9001-15  </td>
              <td>Internal Audit</td>
              <td>Internal auditing is a key to effectively maintaining a Management System and compliance with specified requirements.  Continual Improvement is an integral part of Quality Management Principles of ISO 9001 therefore internal auditing becomes essential to drive business improvement and goes beyond compliance.</td>
              <td>
                <p className={`status tracking-wide hover:bg-secondary transition-all duration-200 hover:scale-110 cursor-pointer hover:shadow hover:shadow-slate-500`}> 2 days </p>
              </td>
            </tr>

            <tr>
              <td>2</td>
              <td>ISO 14001   </td>
              <td>Internal Audit</td>
              <td>ISO 14001 provides a framework for Environmental Management Systems, enabling organisations to play their part in protecting the environment, fulfilling their environmental obligations and becoming more competitive through managing operations in a systematic and environmentally considerate way.</td>
              <td>
                <p className={`status tracking-wide hover:bg-secondary transition-all duration-200 hover:scale-110 cursor-pointer hover:shadow hover:shadow-slate-500`}> 2 days </p>
              </td>
            </tr>

            <tr>
              <td>3</td>
              <td>ISO 45001  </td>
              <td>Internal Audit</td>
              <td>ISO 45001, has been developed to create a framework to improve working conditions and reduce workplace risks. The ISO 45001 standard is intended for use by any organization and can address many, if not all, legal requirements in this area.</td>
              <td>
                <p className={`status tracking-wide hover:bg-secondary transition-all duration-200 hover:scale-110 cursor-pointer hover:shadow hover:shadow-slate-500`}> 2 days </p>
              </td>
            </tr>

            <tr>
              <td>4</td>
              <td>ISO 22000   </td>
              <td>HACCP Training Courses </td>
              <td>Training on food safety management systems enables organizations in the food supply chain to identify and control hazards, demonstrate compliance with food safety requirements, and ensure products and services are safe</td>
              <td>
                <p className={`status tracking-wide hover:bg-secondary transition-all duration-200 hover:scale-110 cursor-pointer hover:shadow hover:shadow-slate-500`}> 2 days </p>
              </td>
            </tr>

            <tr>
              <td>5</td>
              <td>ISO 27001:2022   </td>
              <td>Training Courses</td>
              <td>This course explains ISO 27001:2022 and the processes involved in implementing, monitoring, reviewing and improving an information security management system</td>
              <td>
                <p className={`status tracking-wide hover:bg-secondary transition-all duration-200 hover:scale-110 cursor-pointer hover:shadow hover:shadow-slate-500`}> 2 days </p>
              </td>
            </tr>

            <tr>
              <td>6</td>
              <td>ISO 17025   </td>
              <td>Internal Audit</td>
              <td>ISO 17025 training provides laboratories and testing organizations with the capability to demonstrate that their results are valid, that measurement uncertainty is known, and that results are traceable to national standards.</td>
              <td>
                <p className={`status tracking-wide hover:bg-secondary transition-all duration-200 hover:scale-110 cursor-pointer hover:shadow hover:shadow-slate-500`}> 2 days </p>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </main>
  </div>
  );
};

export default Training;
